import { Component, OnInit, Output ,EventEmitter } from '@angular/core';
import { BreadCrumb } from './breadcrumb';
import { Router } from '@angular/router';
import { UtilsModule } from '../utils/utils.module';
import { GisService } from 'src/app/services/gis/gis.service';
import { AuthloginService } from 'src/app/services/login/authlogin.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
  // styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  @Output() label = new EventEmitter<any>();
  breadCrumbs : BreadCrumb[];
  userdetails : object ={};
  isDisabled;
  fromcomp : any;
  constructor(
    private router: Router,
    private gisService:GisService,
    private utils: UtilsModule,
    private sessionlogin : AuthloginService
  ) { }

  ngOnInit() {
  }
  add(item: BreadCrumb): void{ 
    this.userdetails = {};
    if(!this.breadCrumbs)
      this.breadCrumbs = []; 
    if(!this.exists(item)){
        item['clickable'] = true;
      this.breadCrumbs.push(item); 
     } 
     this.label.emit(this.breadCrumbs)
     
  }
  update(url: string): void{
    
    url = decodeURIComponent(url);
    let options = this.getUrlParams(url);
    this.gisService.getLocationHierarchy(options).subscribe(data =>{
      this.prepareList(data, url, options);
    });
    
      
    
    // this.waterDateOnline.getLocationHierarchy(options).subscribe(data=>{this.prepareList(data, url, options);});
  }
  getUrlParams(url: string): object{
    if(!url || url.length == 0) return {};
    let result = {};
    
    let urlParts = url.split(";");
    for(let i=0; i<urlParts.length; i++){
      if(urlParts[i].indexOf("=") == -1) continue;
      result[urlParts[i].split("=")[0]] = urlParts[i].split("=")[1];
    }

    return result;
  }
  prepareList(data: any, url: string, options: object): void{
    if(!data || data.length == 0) return;
    this.breadCrumbs = [];
    data = data.reverse();
    for(let i=data.length-1; i>=0; i--){
      options['locname'] = data[i]['name'];
      options['loctype'] = data[i]['locType'];
      options['locuuid'] = data[i]['uuid'];
      let finalUrl = url.split(';')[0] + ";";
      for(let key in options){
        finalUrl += (key + "=" + options[key] + ";");
      }
      this.add({label: options['locname'], url: finalUrl})
    }
  }
  ifNotLast(item: BreadCrumb): boolean{
   
    return (this.breadCrumbs.length -1 != this.breadCrumbs.indexOf(item))?true:false;
  }
  exists(item: BreadCrumb): boolean{
    for(let i=0; i< this.breadCrumbs.length; i++){
      if(item.url == this.breadCrumbs[i].url) return true;
    }

    return false;
  }
  pop(): void{
    if(this.breadCrumbs && this.breadCrumbs.length > 0)
      this.breadCrumbs.splice(-1, 1);
  }
  getBreadCrumb(): BreadCrumb[]{
    return this.breadCrumbs;
  }

  navigate(item: BreadCrumb){
    let index = this.breadCrumbs.indexOf(item);
    let length = this.breadCrumbs.length;
    this.breadCrumbs.splice(index+1, length - index + 1);
    
    this.router.navigateByUrl(this.utils.fixedEncodeURIComponent(item.url));
    
  }

}
